<template>
  <section class="filter-area pt-1">
    <v-container class="py-0">
      <v-row no-gutters class="w-100 mx-0">
        <v-col cols="12">
          <v-switch
            v-model="query[filterName]"
            rounded
            v-bind="$attrs"
            v-on="$listeners"
            inset
            @change="handleFilter"
          ></v-switch>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import genericFilter from "./genericFilter.vue";
export default {
  name: "ToggleFilter",
  extends: genericFilter,
};
</script>
